import Page from './Page';
import Component from 'vue-class-component';
import TabBar from './TabBar.vue';
import HeaderComponent from './Header.vue';
import Countries from '../../master_data/countries.json';
import Prefectures from '../../master_data/prefectures.json';
import Occupations from '../../master_data/occupations.json';

type GuestData = {
    id: number;
    addr?: string;
    zip_code?: string;
    prefecture?: number | null;
    name?: string;
    name_kana?: string;
    country?: string;
    dob?: string;
    sex?: number;
    occupation_id?: number;
    occupation_free_input?: string;
    email?: string;
    phone?: string;
    form_memo?: string;
    lastplace?: string;
    destination?: string;
    passport_id?: string;
    passport_path?: boolean;
    face_path?: boolean;
    identification_path?: boolean;
};

import template from './GuestInformation.vue.html';
import { ItemSetting } from '../common/GuestRegisterHelper';
import { format } from 'date-fns';
@Component({ template, components: { TabBar, HeaderComponent } })
export default class GuestInformation extends Page {
    readonly countries = Countries;
    readonly prefectures = Prefectures.filter(
        (prefecture) => prefecture.id != 99
    );
    readonly occupations = Occupations;

    items = {} as Record<string, ItemSetting<GuestData>>;
    previous?: GuestData;
    first: GuestData | null = null;
    guest: GuestData | null = null;

    current_page = -1;

    openGuest(guest: { id: number }) {
        this.app.updateQuery({ page: 'Guest', guest_id: guest.id.toString() });
    }

    country() {
        const country = this.countries.find(
            (c) => c.key === this.guest?.country
        );
        return this.app.getLang() === 'ja'
            ? country?.name.ja
            : country?.name.en;
    }

    occupation() {
        const occupation = this.occupations.find(
            (occupation) => occupation.id === this.guest?.occupation_id
        );
        return occupation?.name || null;
    }

    birthDate() {
        return this.guest?.dob
            ? format(new Date(this.guest.dob), 'yyyy/MM/dd')
            : null;
    }

    gender() {
        switch (this.guest?.sex) {
            case 1:
                return 'man';
            case 2:
                return 'woman';
            case 3:
                return 'other';
            default:
                return null;
        }
    }

    prefecture() {
        const prefecture = this.prefectures.find(
            (p) => p.id === this.guest?.prefecture
        );
        return prefecture?.name || null;
    }

    guestLiveInJapan(): boolean {
        return this.guest?.prefecture !== 99;
    }

    async created() {
        await this.sync();
    }

    async sync() {
        const guest_id = this.app.query.guest_id;
        if (!guest_id) {
            this.app.setPage('Menu');
            return;
        }
        localStorage?.setItem('Mypage:ShownGuest:' + guest_id, 'true');
        try {
            const prop = {
                id: parseInt(guest_id),
                changed: null,
                invoice_issue_request: null,
            };

            const r = await this.app.post('guest', prop);
            if (!r.succeed) throw new Error(r.error);

            this.items = r.items;
            this.previous = r.guest;
            this.guest = Object.assign({}, r.guest);
            this.first = r.first_guest;
        } catch (err) {
            console.error(err);
            const msg = err instanceof Error ? err.message : String(err);
            alert(msg || 'Connection Error');
            this.app.setPage('Menu');
        }
    }
}
